import getUserInfo from 'hub-http/userInfo';
import { useEffect, useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { trackTalkToSalesPql } from '../../../utils/metrics';
import { submitPql } from '../../../utils/pql';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { getSalesPhoneNumber } from '../../../utils/talkToSales';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const VerticalReducedOptionsModal = ({
  apiName,
  isRetail,
  trackingData,
  upgradeConfig,
  onClickChat,
  onClickCall,
  onClose
}) => {
  const [isCallSectionVisible, setIsCallSectionVisible] = useState(false);
  const [firstName, setFirstName] = useState('');
  const trackingProperties = useMemo(() => getTrackingProperties({
    apiName,
    trackingData,
    upgradeConfig,
    sourceKey: 'TALK_TO_SALES'
  }), [apiName, trackingData, upgradeConfig]);
  useEffect(() => {
    void getUserInfo().then(userInfo => {
      setFirstName(userInfo.user.first_name);
    });
  }, []);
  useEffect(() => {
    void submitPql({
      apiName,
      isRetail,
      isAssignable: false,
      trackingData
    });
    if (isRetail) {
      track('communication-methods', Object.assign({
        action: 'viewed retail modal'
      }, trackingProperties));
    } else {
      track('communication-methods', Object.assign({
        action: 'viewed unassignable modal'
      }, trackingProperties));
    }
    trackTalkToSalesPql(trackingData.app);
  }, [apiName, isRetail, trackingData, trackingProperties]);
  const handleCallBackButtonClick = () => {
    track('communication-methods', Object.assign({
      action: 'clicked unassignable phone back button'
    }, trackingProperties));
    setIsCallSectionVisible(false);
  };
  const handleClickCall = () => {
    onClickCall();
    setIsCallSectionVisible(true);
  };
  const {
    phoneNumber,
    countryCode
  } = getSalesPhoneNumber();
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 650,
    "data-test-id": isCallSectionVisible ? 'unassignable-selected-method-call' : 'unassignable-modal',
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      }), /*#__PURE__*/_jsx(Text, {
        textAlign: "start",
        marginBlockStart: "-800",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.expertTitle"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      paddingBlockEnd: "1000",
      alignItems: "start",
      display: "flex",
      children: isCallSectionVisible ? /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        "data-test-id": "communication-call-submit-success",
        paddingBlockStart: "500",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h4",
          margin: "0",
          children: phoneNumber
        }), countryCode && /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `SharedI18nStrings.countryCodes.${countryCode}`
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleCallBackButtonClick,
          use: "link",
          marginBlockStart: "800",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.talkToSales.communicationMethods.backButton"
          })
        })]
      }) : /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "300",
        children: [!isCallSectionVisible && /*#__PURE__*/_jsx(Text, {
          as: "h1",
          textAlign: "start",
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.talkToSales.communicationMethods.subtitle",
            options: {
              firstName
            }
          })
        }), /*#__PURE__*/_jsx(SelectableButton, {
          "data-test-id": "unassignable-chat",
          selected: false,
          size: "large",
          block: true,
          blockSize: "165px",
          title: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "row",
            gap: "400",
            alignItems: "center",
            paddingInlineStart: "400",
            paddingBlockEnd: "400",
            children: [/*#__PURE__*/_jsx(Illustration, {
              name: "contacts-chat",
              height: 90
            }), /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "column",
              gap: "200",
              alignItems: "start",
              children: [/*#__PURE__*/_jsxs(Flex, {
                flexDirection: "row",
                gap: "200",
                alignItems: "center",
                children: [/*#__PURE__*/_jsx(Text, {
                  as: "h5",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "purchaseMotions.talkToSales.communicationMethods.chatWithUs"
                  })
                }), /*#__PURE__*/_jsx(Badge, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "purchaseMotions.talkToSales.communicationMethods.recommended"
                  })
                })]
              }), /*#__PURE__*/_jsx(Text, {
                as: "p",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "purchaseMotions.talkToSales.communicationMethods.getQuickAnswers"
                })
              })]
            })]
          }),
          onClick: () => onClickChat()
        }), /*#__PURE__*/_jsx(SelectableButton, {
          "data-test-id": "unassignable-call",
          size: "large",
          block: true,
          blockSize: "165px",
          title: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "row",
            gap: "400",
            alignItems: "center",
            paddingInlineStart: "400",
            paddingBlockEnd: "400",
            children: [/*#__PURE__*/_jsx(Illustration, {
              name: "calling-small",
              height: 90
            }), /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "column",
              gap: "200",
              alignItems: "start",
              children: [/*#__PURE__*/_jsx(Text, {
                as: "h5",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "purchaseMotions.talkToSales.communicationMethods.callUs"
                })
              }), /*#__PURE__*/_jsx(Text, {
                as: "p",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "purchaseMotions.talkToSales.communicationMethods.getCustomerSupportNumber"
                })
              })]
            })]
          }),
          onClick: handleClickCall
        })]
      })
    })]
  });
};